module.exports = __webpack_public_path__ + "static/media/spinner.79cd1b1a.svg";